import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from 'wix-style-react'
import { ArrowLeftThin, ArrowRightThin } from 'wix-style-react/src/Icons'
import * as _ from 'lodash'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

class SimplePagination extends Component {

  constructor (props) {
    super(props)
    this.state = {
      offset: 0
    }
  }

  getVisibleItems () {
    const { offset } = this.state
    const { items, itemsVisible } = this.props
    let end = offset + itemsVisible
    if (end > items.length) end = items.length
    return _.slice(items, offset, end)
  }

  moveBackward = () => {
    const { offset } = this.state
    if (offset > 0) {
      this.setState({
        offset: offset - 1
      })
    }
  }

  canMoveForward () {
    const { offset } = this.state
    const { items, itemsVisible } = this.props
    return offset < items.length - itemsVisible
  }

  moveForward = () => {
    const { offset } = this.state
    if (this.canMoveForward()) {
      this.setState({
        offset: offset + 1
      })
    }
  }

  renderWithArrows () {
    const { offset } = this.state
    const { ItemsContainer } = this.props
    return (
      <Container>
        <Button
          height='small'
          theme='icon-standard'
          onClick={this.moveBackward}
          disabled={offset <= 0}
        >
          <ArrowLeftThin size='16px' />
        </Button>

        <ItemsContainer>
          {this.getVisibleItems()}
        </ItemsContainer>

        <Button
          height='small'
          theme='icon-standard'
          onClick={this.moveForward}
          disabled={!this.canMoveForward()}
        >
          <ArrowRightThin size='16px' />
        </Button>
      </Container>
    )
  }

  renderSimple () {
    const { ItemsContainer } = this.props
    return (
      <ItemsContainer>
        {this.getVisibleItems()}
      </ItemsContainer>
    )
  }

  render () {
    const { items, itemsVisible } = this.props
    if (items.length > itemsVisible) {
      return this.renderWithArrows()
    } else {
      return this.renderSimple()
    }
  }
}

SimplePagination.defaultProps = {
  items: [],
  itemsVisible: 1
}

SimplePagination.propTypes = {
  ItemsContainer: PropTypes.func.isRequired,
  items: PropTypes.array,
  itemsVisible: PropTypes.number
}

export default SimplePagination



// WEBPACK FOOTER //
// ./src/components/shared/SimplePagination.js